/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';

/**
 * 
 * @export
 * @interface LocationPaymentEvent
 */
export interface LocationPaymentEvent {
    /**
     * 
     * @type {PaymentProvider}
     * @memberof LocationPaymentEvent
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof LocationPaymentEvent
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof LocationPaymentEvent
     */
    pspTerminalId: string;
    /**
     * 
     * @type {LocationPaymentEventStateEnum}
     * @memberof LocationPaymentEvent
     */
    state: LocationPaymentEventStateEnum;
    /**
     * 
     * @type {number}
     * @memberof LocationPaymentEvent
     */
    timestampMs: number;
}


/**
 * @export
 */
export const LocationPaymentEventStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED'
} as const;
export type LocationPaymentEventStateEnum = typeof LocationPaymentEventStateEnum[keyof typeof LocationPaymentEventStateEnum];


/**
 * Check if a given object implements the LocationPaymentEvent interface.
 */
export function instanceOfLocationPaymentEvent(value: object): value is LocationPaymentEvent {
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('pspTerminalId' in value) || value['pspTerminalId'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('timestampMs' in value) || value['timestampMs'] === undefined) return false;
    return true;
}

export function LocationPaymentEventFromJSON(json: any): LocationPaymentEvent {
    return LocationPaymentEventFromJSONTyped(json, false);
}

export function LocationPaymentEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationPaymentEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentReference': json['paymentReference'],
        'pspTerminalId': json['pspTerminalId'],
        'state': json['state'],
        'timestampMs': json['timestampMs'],
    };
}

export function LocationPaymentEventToJSON(json: any): LocationPaymentEvent {
    return LocationPaymentEventToJSONTyped(json, false);
}

export function LocationPaymentEventToJSONTyped(value?: LocationPaymentEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentReference': value['paymentReference'],
        'pspTerminalId': value['pspTerminalId'],
        'state': value['state'],
        'timestampMs': value['timestampMs'],
    };
}

